import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../codegen/Localize';
import { RefreshPropertyHelper } from '../../../ts/helpers/RefreshPropertyHelper';
import { IDataSourceDetailInfo } from '../../../ts/models/IDataSourceInfo';

export interface RemoteRefreshPropertiesButtonProps {
  handleClick: () => void;
  datasource: IDataSourceDetailInfo;
  refreshPropertiesAreEditable: () => boolean;
}

export function RemoteRefreshPropertiesButton(props: RemoteRefreshPropertiesButtonProps): JSX.Element {
  const buttonStyle = {
    marginLeft: TabStyles!.Spacing!.MediumSpace
  };

  const text = RefreshPropertyHelper.getCurrentRefreshLocation(props.datasource);

  return (
    <span>
      <span>{Messages.remoteRefreshPropertiesPrompt()}</span>
        <ButtonWidget
          style={buttonStyle}
          buttonType={ButtonType.Outline}
          children={text}
          disabled={!props.refreshPropertiesAreEditable()}
          testId={RemoteRefreshPropertiesButtonTestIds.Button}
          handleClick={props.handleClick}/>
      </span>
  );
}

export namespace RemoteRefreshPropertiesButtonTestIds {
  export const Button = 'remote-refresh-properties-button';
}
